import { z } from 'zod/v4';

export const HIEvidenceRequestDTO = z.object({
  ci_id: z.uuid(),
  sot_id: z.uuid(),
  after: z.string().nullish(),
});
export type HIEvidenceRequest = z.infer<typeof HIEvidenceRequestDTO>;

export const HIEvidenceItemDTO = z.object({
  media_id: z.uuid(),
  occurred_at: z.string(),
  type: z.string(),
});
export type HIEvidenceItem = z.infer<typeof HIEvidenceItemDTO>;

export const HIEvidenceResponseDTO = z.object({
  items: z.array(HIEvidenceItemDTO),
  has_more: z.boolean(),
  after: z.string().nullish(),
});
export type HIEvidenceResponse = z.infer<typeof HIEvidenceResponseDTO>;